import * as React from "react";
import type { SVGProps } from "react";

const SvgShippingCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={16}
    viewBox="0 0 21 16"
    {...props}
  >
    <path
      fill="#142745"
      fillRule="evenodd"
      d="M3.188 7.812a1.875 1.875 0 0 0-2.644 0 1.87 1.87 0 0 0 0 2.64l4.934 4.931c.022.022.027.053.051.078.367.365.851.544 1.335.54.484.004.966-.175 1.333-.54.023-.025.03-.056.054-.078L20.455 3.188a1.875 1.875 0 0 0 0-2.645 1.877 1.877 0 0 0-2.641 0l-10.95 10.94-3.675-3.671z"
    />
  </svg>
);
export default SvgShippingCheckMark;
